<div class="media-preview-dialog">
  <div class="dialog-header">
    <div class="dialog-title">
      <span *ngIf="data.fileName">{{ data.fileName }}</span>
      <span *ngIf="!data.fileName">{{ getMediaTypeLabel() }} Preview</span>
    </div>
    <div class="dialog-actions">
      <button mat-icon-button
              (click)="downloadMedia()"
              [matTooltip]="'TTP.DOWNLOAD_ATTACHMENT' | translate"
              class="action-button"
              *ngIf="data.downloadEnabled">
        <span class="material-symbols-outlined">download</span>
      </button>
      <button mat-icon-button
              (click)="close()"
              [matTooltip]="'POPUP.CLOSE' | translate"
              class="action-button close-button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </div>

  <div class="dialog-content">
    <!-- Image Preview -->
    <img *ngIf="data.mediaType === FileCategory.Image"
         [src]="data.mediaUrl"
         alt="Image Preview"
         class="preview-media preview-image">

    <!-- Video Preview -->
    <video *ngIf="data.mediaType === FileCategory.Video"
           [src]="data.mediaUrl"
           class="preview-media preview-video"
           controls
           controlsList="nodownload"
           autoplay>
      Your browser does not support the video tag.
    </video>

    <!-- Audio Preview -->
    <audio *ngIf="data.mediaType === FileCategory.Audio"
           [src]="data.mediaUrl"
           class="preview-media preview-audio"
           controls
           controlsList="nodownload"
           autoplay>
      Your browser does not support the audio element.
    </audio>
  </div>
</div>
